import React, { useState, useMemo } from "react";

export function OtpFaq({
    faqs,
    allowMultiple = true,
}) {
    const items = useMemo(() => (
        faqs && faqs.length
            ? faqs
            : [
                {
                    question: "How to sign into OTP?",
                    answer:
                        "If APP is associated with OTP for authentication, you may click login button and the system will direct you to the OTP authentication site to sign in. The sign in page as shown in Fig. 1.",
                    image:
                        "images/faq-images/01b.png",
                    alt: "OTP Sign in",
                    caption: "Fig 1. OTP Sign in"
                },
                {
                    question: "How to create a new OTP account?",
                    answer:
                        "<div id='01' class='faq-step'><div class='faq-inst'>1. User clicks on Create Account button.</div><div class='faq-img'><img src='images/faq-images/01a.png' alt='fig 1'/><figcaption class=''>Fig. 1 OTP Sign In</figcaption></div></div><div id='02' class='faq-step'><div class='faq-inst'>2. User enters their email address in the Email field, then clicks Next button.</div><div class='faq-img'><img src='images/faq-images/04a.png' alt='fig 2'/><figcaption class=''>Fig. 2 Create Account</figcaption></div></div><div id='03' class='faq-step'><div class='faq-inst'>3. Note - there is validation enforced on the Email field, ensuring that a validly-formed email address is entered.</div><div class='faq-img'><img src='images/faq-images/03a.png' alt='fig 3'/><figcaption class=''>Fig. 3 Create Account Validation</figcaption></div></div><div id='04' class='faq-step'><div class='faq-inst'>4. A one-time verification code is sent to the email address entered.  User retrieves the verification code from their email, and enters it in the One-time Security Code field. Once code is entered, user clicks Next button.</div><div class='faq-img'><img src='images/faq-images/05a.png' alt='fig 4'/><figcaption class=''>Fig. 4 Enter Validation Code</figcaption></div></div><div id='05' class='faq-step'><div class='faq-inst'>5. Enter user, company, and phone information in the Create Account form.  Note - all fields in user and company sections are required.</div><div class='faq-img'><img src='images/faq-images/09a.png' alt='fig 5'/><figcaption class=''>Fig. 5 Enter User Information</figcaption></div></div><div id='06' class='faq-step'><div class='faq-inst'>6. To use a cell phone number for SMS verification, user must enter a valid cell phone number in the Phone field.  User must opt-in to receive pin codes via SMS.</div><div class='faq-img'><img src='images/faq-images/10a.png' alt='fig 6'/><figcaption class=''>Fig. 6 Opt in or Opt Out of SMS Notification</figcaption></div></div><div id='07' class='faq-step'><div class='faq-inst'>7. When the user agrees to receive PIN codes via SMS, a notification is displayed that the user will be prompted to verify the number after saving.  Enter phone number and click the Save button.</div><div class='faq-img'><img src='images/faq-images/11a.png' alt='fig 7'/><figcaption class=''>Fig. 7 Notification to Confirm Phone Number</figcaption></div></div><div id='08' class='faq-step'><div class='faq-inst'>8. User enters the one-time verification code sent to the cell phone in the One-time Security Code field.</div><div class='faq-img'><img src='images/faq-images/14a.png' alt='fig 8'/><figcaption class=''>Fig. 8 Enter Security Code</figcaption></div></div><div id='09' class='faq-step'><div class='faq-inst'>9. User can proceed to application by clicking Continue to XXX button.  User can also edit their account by clicking Edit Account button.</div><div class='faq-img'><img src='images/faq-images/15a.png' alt='fig 9'/><figcaption class=''>Fig. 9 Success Notification</figcaption></div></div><div id='09' class='faq-step'></div>",

                } //},
                //{
                //    question: "How to get one time code from email?",
                //    answer:
                //        "Answer to getting code from email.",
                    
                //},
                //{
                //    question: "How to get one time code from email?",
                //    answer:
                //        "Answer to getting code from email.",

                //},

            ]
    ), [faqs]);

    const [openSet, setOpenSet] = useState(() => new Set([1]));

    const toggle = (i) => {
        setOpenSet((prev) => {
            const next = new Set(prev);
            if (next.has(i)) {
                next.delete(i);
            } else {
                if (!allowMultiple) next.clear();
                next.add(i);
            }
            return next;
        });
    };

    return (
        <div id="otp-faq">
            <div>
                <header className="mb-8">
                    <h1 className="text-3xl font-bold tracking-tight">FAQ</h1>
                {/*    <p className="text-sm text-neutral-600 mt-1">Click a question to reveal the answer and image.</p>*/}
                </header>

                <div className="space-y-4">
                    {items.map((item, i) => {
                        const isOpen = openSet.has(i);
                        const contentId = `faq-content-${i}`;
                        const buttonId = `faq-button-${i}`;
                        return (
                            <section key={i} className="border border-neutral-200 bg-white rounded-2xl shadow-sm overflow-hidden" style={{ margin: '20px 0' }}>
                                <h2>
                                    <button
                                        id={buttonId}
                                        className="w-full text-left px-5 py-4 flex items-center justify-between gap-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                                        aria-expanded={isOpen}
                                        aria-controls={contentId}
                                        onClick={() => toggle(i)}
                                    >
                                        <span className="font-medium">{item.question}</span>
                                        <span
                                            className={`inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-neutral-300 transition-transform ${isOpen ? "rotate-45" : "rotate-0"
                                                }`}
                                            aria-hidden
                                        >

                                            {isOpen ? (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                style={{ width: 16, height: 16, color: '#111' }} 
                                                aria-hidden="true"
                                            >
                                                <path d="M6 15l6-6 6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
                                                </svg>) : (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    style={{ width: 16, height: 16, color: '#111' }}
                                                    aria-hidden="true"
                                                >
                                                    <path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
                                                </svg>)
                                                }
                                        </span>
                                    </button>
                                </h2>

                                <div
                                    id={contentId}
                                    role="region"
                                    aria-labelledby={buttonId}
                                    className={`grid transition-[grid-template-rows] duration-300 ease-out ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                                        }`}
                                >
                                    <div className="overflow-hidden">
                                        {isOpen && <div className="faq-container" style={{ display: 'flex', paddingBottom: "0 !important" }}>
                                            
                                            <div className="faq-step">
                                            <div className="faq-inst" dangerouslySetInnerHTML={{ __html: item.answer }} />                                       
                                        
                                    {/*<div className="px-5 pb-5 pt-0 faq-container" style={{ display: 'flex', paddingBottom: "0 !important" }} >*/}
                                    {/*    {isOpen && <p className="text-neutral-700 leading-relaxed" style={{ width: '70%' }}>{item.answer}</p>}*/}

                                            {item.image && (
                                                <figure className="faq-img">
                                                    <img
                                                            src={item.image}
                                                            alt="FAQ related"
                                                            loading="lazy"
                                                            className=""
                                                    />
                                                    {item.caption && (
                                                        <figcaption>
                                                            {item.caption}
                                                        </figcaption>
                                                    )}
                                                </figure>
                                                    )}
                                            </div>                                            
                                        </div>
                                        }
                                    </div>
                                </div>
                            </section>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
